import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContentCenter from "../../../components/screen/common-screen-content-center/commonScreenContentCenter";
import moment from 'moment'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import {
    employeeAttendanceCheckRequest, employeeClockInRequest, employeeClockInRequestStatus,
    employeeClockOutRequest, employeeClockOutRequestStatus
} from '../../../redux/employee/employee.action'
import { API_CONSTANTS } from "../../../utils/AppConstants";
import { displayErrorToast, displaySuccessToast, isEmpty } from "../../../utils/Utils";
import CommonButton from "../../../components/button/common-button/commonButton";

const EmployeeClockIn = props => {
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { attendanceCheckSuccess, attendanceCheckError, clockInSuccess,
        clockInError, clockInReqStatus, clockOutSuccess, clockOutError, clockOutReqStatus
    } = useSelector((state) => state.employee)
    const dispatch = useDispatch()
    const [showClockInView, setShowClockInView] = useState(false)
    const [showClockOutView, setShowClockOutView] = useState(false)
    const [showAlreadyClockedOut, setShowAlreadyClockedOut] = useState(false)

    useEffect(() => {
        getAttendanceStatus()
    }, [])

    const getAttendanceStatus = () => {
        setLoading(true)
        const data = {
            employeeId: user.data.userDetails.employeeId,
            businessId: employeeSelectedBusiness,
            locationId: employeeSelectedLocation
        }
        dispatch(employeeAttendanceCheckRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(attendanceCheckSuccess)) {
            setLoading(false)
            if (attendanceCheckSuccess.data.isOnGoingSession === true) {
                if (attendanceCheckSuccess.data.isClockedOut === false) {
                    setShowAlreadyClockedOut(true)
                    setShowClockInView(false)
                    setShowClockOutView(false)
                } else {
                    setShowAlreadyClockedOut(false)
                    setShowClockInView(false)
                    setShowClockOutView(true)
                }

            } else {
                setShowClockInView(true)
                setShowClockOutView(false)
            }
        } else if (!isEmpty(attendanceCheckError)) {
            setLoading(false)
            setShowClockInView(false)
            setShowClockOutView(false)
        }
    }, [attendanceCheckSuccess, attendanceCheckError])

    useEffect(() => {
        if (clockInReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(clockInSuccess.data?.message)
            getAttendanceStatus()
        } else if (clockInReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(clockInError.message)
        }
        if (clockInReqStatus?.length) {
            dispatch(employeeClockInRequestStatus(''))
        }
    }, [clockInSuccess, clockInError, clockInReqStatus])

    useEffect(() => {
        if (clockOutReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(clockOutSuccess.data?.message)
            getAttendanceStatus()
        } else if (clockOutReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(clockOutError.message)
        }
        if (clockOutReqStatus?.length) {
            dispatch(employeeClockOutRequestStatus(''))
        }
    }, [clockOutSuccess, clockOutError, clockOutReqStatus])

    const handleClockInClick = () => {
        setLoading(true)
        const data = {
            employeeId: user.data.userDetails.employeeId,
            businessId: parseFloat(employeeSelectedBusiness),
            locationId: parseFloat(employeeSelectedLocation)
        }
        dispatch(employeeClockInRequest(data))
    }

    const handleClockOutClick = () => {
        if (isEmpty(attendanceCheckSuccess)) {
            displayErrorToast('Something went wrong. Please try after some time')
        } else {
            setLoading(true)
            const data = {
                employeeId: user.data.userDetails.employeeId,
                attendanceId: attendanceCheckSuccess.data.attendanceId
            }
            dispatch(employeeClockOutRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContentCenter>
                <h4 className="eci-heading-container">Clock-In/Out</h4>
                <div className="eci-img-container">
                    <img src={require('../../../assets/emp_clock_in.png')} className="img" alt="img" />
                </div>
                {showClockInView && <CommonButton
                    label='Clock-In'
                    onClick={() => { handleClockInClick() }}
                />
                }
                {showClockOutView && <div className="eci-clock-out-container">
                    <p className="eci-clock-in-label">You are currently clock-in</p>
                    {!isEmpty(attendanceCheckSuccess) && <div className="eci-clock-in-time-label">Start time <span className="up-bold-label">{moment.utc(attendanceCheckSuccess.data.startTime).local().format("hh:mm a \\o\\n MMM DD, ' YY")}</span></div>}
                    <CommonButton
                        label='Clock-Out'
                        onClick={() => { handleClockOutClick() }}
                    />
                </div>}
                {showAlreadyClockedOut && <div className="eci-clock-out-container">
                    <p className="eci-clock-in-label">You are already clocked-out for the day</p>
                </div>}
            </CommonScreenContentCenter>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EmployeeClockIn